module.exports = __webpack_public_path__ + "static/media/Corn.058a640e.webp";